var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState } from 'react';
import { ExclusionMultiSelect } from './ExclusionMultiSelect';
const meta = {
    title: 'Features/AiInspectionManager/ExclusionMultiSelect',
    component: ExclusionMultiSelect,
    parameters: { layout: 'centered' }
};
export default meta;
const ACCOUNTS = [
    { value: '1', label: 'Walmart' },
    { value: '2', label: 'Target' },
    { value: '3', label: 'Costco' }
];
/** Static option list (accounts / tags) with client-side search. */
export const StaticOptions = {
    render: () => {
        const [selected, setSelected] = useState(['1']);
        return (React.createElement("div", { style: { width: 320 } },
            React.createElement(ExclusionMultiSelect, { label: "Accounts to exclude", placeholder: "Select accounts\u2026", searchPlaceholder: "Search accounts\u2026", emptyMessage: "No options available.", options: ACCOUNTS, selected: selected, onChange: setSelected })));
    }
};
/** Async loader (buildings) — short queries resolve to an empty list. */
export const AsyncSearch = {
    render: () => {
        const [selected, setSelected] = useState([]);
        const asyncSearch = (query) => __awaiter(void 0, void 0, void 0, function* () {
            yield new Promise((resolve) => {
                setTimeout(resolve, 200);
            });
            return [
                { value: '10', label: `${query} — Main St` },
                { value: '11', label: `${query} — 2nd Ave` }
            ];
        });
        return (React.createElement("div", { style: { width: 320 } },
            React.createElement(ExclusionMultiSelect, { label: "Buildings to exclude", placeholder: "Select buildings\u2026", searchPlaceholder: "Search by name or address\u2026", emptyMessage: "Type at least two characters to search buildings.", asyncSearch: asyncSearch, selected: selected, onChange: setSelected })));
    }
};
